import React from 'react';
import { StepIcon } from '@mui/material';

export default function StepIconOutlined(props) {
  const { active, completed, icon } = props;

  if (active || completed) {
    return <StepIcon {...props} />;
  }

  return (
    <span
      style={{
        width: 24,
        height: 24,
        borderRadius: '50%',
        backgroundColor: '#FFFFFF',
        // Draw an inner teal ring without changing outer size
        boxShadow: 'inset 0 0 0 2px #8AC7BC',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#000000',
        fontSize: 12,
        fontFamily: 'inherit',
      }}
    >
      {icon}
    </span>
  );
}
